import { render, staticRenderFns } from "./InputQuill.vue?vue&type=template&id=9ef189cc&"
import script from "./InputQuill.vue?vue&type=script&lang=js&"
export * from "./InputQuill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports